export default __webpack_public_path__ + "static/media/contacts.03e1cf4c.svg";